module.exports = __webpack_public_path__ + "static/img/cygn8.053e15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn8.png
// module id = 317
// module chunks = 0